import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export function LicenseBanner() {
  const { licenseStatus } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  const { warningType, warningDays, graceDays } = licenseStatus ?? {};

  // Determine what to show
  let days: number | undefined;
  let message: string | undefined;
  let urgent = false;

  if (warningType === 'trial' && warningDays != null) {
    days = warningDays;
    message = `Your free trial expires in ${days} day${days === 1 ? '' : 's'}.`;
    urgent = days <= 3;
  } else if (warningType === 'license' && warningDays != null) {
    days = warningDays;
    message = `Your license expires in ${days} day${days === 1 ? '' : 's'}.`;
    urgent = days <= 3;
  } else if (warningType === 'grace' && graceDays != null) {
    days = graceDays;
    message = `Your license has expired — ${days} day${days === 1 ? '' : 's'} of grace period remaining.`;
    urgent = true;
  }

  if (!message) return null;

  return (
    <div className={`flex items-center justify-between px-4 py-2 text-sm ${urgent ? 'bg-red-600 text-white' : 'bg-amber-500 text-white'}`}>
      <span>
        ⚠️ {message}{' '}
        <button
          onClick={() => navigate('/settings/license')}
          className="underline font-semibold hover:no-underline"
        >
          {warningType === 'trial' ? 'Upgrade now' : 'Renew now'}
        </button>
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-4 opacity-80 hover:opacity-100 text-lg leading-none"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
